import { useTranslation } from "react-i18next";
import { Modal } from "../common/Modal";
import styles from "./ResetConfirmation.module.css";

interface ResetConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
  isResetting: boolean;
}

export function ResetConfirmation({ onConfirm, onCancel, isResetting }: ResetConfirmationProps) {
  const { t } = useTranslation();

  return (
    <Modal onClose={onCancel} preventClose={isResetting} className={styles.modal}>
      <div className={styles.iconWrapper}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 6h18" />
          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      </div>

      <h2 className={styles.title}>{t("voiceProfile.resetTitle")}</h2>

      <p className={styles.message}>{t("voiceProfile.resetMessage")}</p>

      <div className={styles.warning}>
        <svg
          className={styles.warningIcon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span className={styles.warningText}>{t("voiceProfile.resetWarning")}</span>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={onCancel}
          disabled={isResetting}
        >
          {t("common.cancel")}
        </button>
        <button
          type="button"
          className={styles.resetButton}
          onClick={onConfirm}
          disabled={isResetting}
        >
          {isResetting ? (
            <>
              <span className={styles.spinner} />
              {t("voiceProfile.resetting")}
            </>
          ) : (
            t("voiceProfile.resetButton")
          )}
        </button>
      </div>
    </Modal>
  );
}
